/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desired_Employment_Types_LabelInputs */

const en_desired_employment_types_label = /** @type {(inputs: Desired_Employment_Types_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired types of employment`)
};

const de_desired_employment_types_label = /** @type {(inputs: Desired_Employment_Types_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewünschte Anstellungsarten`)
};

/**
* | output |
* | --- |
* | "Desired types of employment" |
*
* @param {Desired_Employment_Types_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const desired_employment_types_label = /** @type {((inputs?: Desired_Employment_Types_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desired_Employment_Types_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_desired_employment_types_label(inputs)
	return en_desired_employment_types_label(inputs)
});